import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import Download from 'components/download.js';
import CompanyService from 'services/company2';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import SupplierService from 'services/supplier.ts';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import BuyoffFns from 'functions/buyoff';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import * as React from 'react';
import User from 'services/user2';
import Enum from 'services/enum2';
import Drawer from '@material-ui/core/Drawer';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import ModalService from 'services/modal';
import Http from 'services/http2';
import CommonFns from 'functions/common.ts';
function BuyoffReportDetail(props) {
  const Config = {
    sale: {
      title: '物料准入报告详情',
      apiPath: '/b2bCustomerMaterialReport/detail',
      enumMainKey: '',
      companyCodeKey: 'customerCode',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Material_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Material_Report_Result',
          subKey: 'materialReportResult',
          value: 'materialReportResultName'
        }
      ],
      idField: 'materialReportXkNo'
    },
    purchase: {
      title: '物料准入报告详情',
      apiPath: '/b2bMaterialReport/detail',
      deleteApiPath: '/b2bMaterialReport/delete',
      publishApiPath: '/b2bMaterialReport/publish',
      rejectApiPath: '/b2bMaterialReport/back',
      enumMainKey: '',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Material_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Material_Report_Result',
          subKey: 'materialReportResult',
          value: 'materialReportResultName'
        }
      ],
      idField: 'materialReportXkNo',
      wfmCode: '1011'
    }
  };

  const styles = {
    overHide: {
      width: '100%',
      overflowX: 'scroll'
    }
  };

  const columns = [
    { id: 'icon', label: '', maxWidth: 50 },
    { id: 'itemNo', label: 'No.', minWidth: 30 },
    { id: 'itemName', label: '评审项目', minWidth: 230 },
    {
      id: 'statisticsInfo',
      value: 'validMaxScore',
      label: '总分',
      minWidth: 120,
      format: value => value
    },
    {
      id: 'statisticsInfo',
      value: 'selfScoreRate',
      label: '自评分',
      minWidth: 120,
      format: value => value + '%'
    },
    {
      id: 'statisticsInfo',
      value: 'auditScore',
      label: '评审得分',
      minWidth: 140,
      format: value => value
    },
    {
      id: 'statisticsInfo',
      value: 'auditScoreRate',
      label: '总得分',
      minWidth: 120,
      format: value => value + '%'
    },
    {
      id: 'itemWeight',
      label: '权重占比',
      minWidth: 140,
      format: value => value + '%'
    },
    {
      id: 'statisticsInfo',
      value: 'overallScore',
      label: '结果',
      minWidth: 120,
      format: value => value
    }
  ];

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    forceUpdate,
    detail,
    setDetail,
    workflow,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [auditModal, setAuditModal] = useState(false);

  //处理详情数据
  self.afterGetDetail = function (data) {
    BuyoffFns.parseReportDetail(data, self.isPurchase);
    BuyoffFns.getStatisticsInfo(data, self.isPurchase);
    for (
      let i = 0;
      i < data.materialInspection.inspectionItemList.length;
      i++
    ) {
      data.materialInspection.inspectionItemList[i].open = false;
    }
    Enum.getList('B02_Material_Report_Result').then(list => {
      data.reportResultList = list.map(item => {
        return {
          id: item.subKey,
          text: item.subValue
        };
      });
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  /** 采购方操作 begin **/

  // 删除
  function deleteOrder() {
    let postbody = getPostbody(config.deleteApiPath);
    SupplierService.deleteBuyoffReport(
      postbody,
      () => {
        setRedirect('/mp/purchase/supplier/buyoff-report/list');
      },
      dispatch
    );
  }

  //退回
  function handleReject() {
    let postbody = getPostbody(config.rejectApiPath);
    SupplierService.rejectBuyoffReport(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //发布
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    SupplierService.publishBuyoffReport(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //审核
  function audit() {
    if (Util.isEmpty(detail.materialReportResult)) {
      ModalService.showError('报告评审结果不能为空', dispatch);
      return;
    }
    if (
      detail.materialReportResult === 2 &&
      Util.isEmpty(detail.useDescription)
    ) {
      ModalService.showError('有条件使用时，请填写说明', dispatch);
      return;
    }

    let postbody = {
      companyCode: companyCode,
      materialReportXkNo: self.id,
      materialReportResult: detail.materialReportResult,
      useDescription: detail.useDescription,
      apiPath: '/b2bMaterialReport/audit'
    };
    ModalService.showLoading(dispatch);
    Http.post('/api/cloudCenter', postbody).then(response => {
      ModalService.hideLoading(dispatch);
      if (response.success) {
        ModalService.showTip('操作成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
      setAuditModal(false);
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      materialReportXkNo: detail.materialReportXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey =
        businessType === 9 ? obj.poXkNo + '_' + obj.lineNo : obj.poXkNo,
      xkNo = obj.poXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  let noDiff = (
    <p>
      <i className="icon-success"></i> 答交无差异
    </p>
  );

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">物料</label>
              <div className="order-detail-value">{detail.productName}</div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'order-detail-value u-sign ' +
                  CommonFns.getStatusClass('ItemReport', detail.status)
                }
              >
                {detail.statusName}
              </div>
            </li>
            {/* 审批流状态 仅开启后才显示 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
            <li className={self.isPurchase && moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">
                {self.isPurchase ? '采购方' : '客户'}
              </label>
              <div className="order-detail-value">
                {self.isPurchase
                  ? self.companyInfo.companyName
                  : detail.innerCustomerName}
              </div>
            </li>
            <li className={!self.isPurchase && moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">供应商</label>
              <div className="order-detail-value">
                {detail.innerVendorName}({detail.innerVendorCode})
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">报告编码</label>
              <div className="order-detail-value">
                {detail.materialReportXkNo}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">物料分类</label>
              <div className="order-detail-value">
                {detail.materialCategoryName}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">产品/机种</label>
              <div className="order-detail-value">{detail.materialProduct}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">工厂</label>
              <div className="order-detail-value">
                {detail.profitCenterName}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">评审结果</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass(
                    'reportResult',
                    detail.materialReportResult
                  )
                }
              >
                {detail.materialReportResultName}
              </div>
            </li>
            {!Util.isEmpty(detail.fileMd5s) && (
              <li className={moreSign1 ? 'hide' : ''}>
                <label className="order-detail-label">附件</label>
                <div className="order-detail-value">
                  <span
                    className="attachment"
                    onClick={() => showFileList(35, detail)}
                  >
                    {detail.fileMd5s.length}个附件
                    <i className="icon-attachment"></i>
                  </span>
                </div>
              </li>
            )}
          </ul>
          <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>汇总信息</label>
          </div>
          <div className="order-detail-list">
            <div style={styles.overHide}>
              <Table aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    {columns
                      .filter(column => column.id !== 'icon')
                      .map((column, i) => (
                        <TableCell
                          key={i}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!Util.isEmpty(
                    detail.materialInspection?.inspectionItemList
                  ) &&
                    detail.materialInspection?.inspectionItemList.map(
                      (row, i) => {
                        return (
                          <React.Fragment key={i}>
                            <TableRow hover role="checkbox" tabIndex={-1}>
                              {columns.map((column, j) => {
                                const value =
                                  column?.id !== 'statisticsInfo' ? (
                                    column.id === 'icon' ? (
                                      <div
                                        key={j}
                                        onClick={() => {
                                          row.open = !row.open;
                                          forceUpdate();
                                        }}
                                      >
                                        {row.open ? (
                                          <KeyboardArrowUpIcon />
                                        ) : (
                                          <KeyboardArrowDownIcon />
                                        )}
                                      </div>
                                    ) : (
                                      row[column.id]
                                    )
                                  ) : (
                                    row[column.id][column.value]
                                  );
                                return (
                                  <TableCell key={j} align={column.align}>
                                    {column.format && typeof value === 'number'
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                            {row.open && !Util.isEmpty(row.itemList) && (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={i}
                              >
                                <TableCell colSpan={9}>
                                  <Collapse
                                    in={row.open}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <Table size="small" aria-label="purchases">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>No.</TableCell>
                                          <TableCell>评审项目</TableCell>
                                          <TableCell>本项总分</TableCell>
                                          <TableCell>评分说明</TableCell>
                                          {detail.status !== 0 && (
                                            <React.Fragment>
                                              <TableCell>自评分</TableCell>
                                              <TableCell>是否涉及</TableCell>
                                              <TableCell>供应商说明</TableCell>
                                              <TableCell>评审得分</TableCell>
                                              <TableCell>评审说明</TableCell>
                                            </React.Fragment>
                                          )}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {!Util.isEmpty(row.itemList) &&
                                          row.itemList.map((item1, k) => (
                                            <React.Fragment key={k}>
                                              <TableRow>
                                                <TableCell>
                                                  {item1.itemNo}
                                                </TableCell>
                                                <TableCell>
                                                  {item1.itemName}
                                                </TableCell>
                                                <TableCell>
                                                  {item1.itemScore}
                                                </TableCell>
                                                <TableCell>
                                                  {item1.itemDesc}
                                                </TableCell>
                                                {detail.status !== 0 && (
                                                  <React.Fragment>
                                                    <TableCell>
                                                      {item1.involveFlag === 1
                                                        ? item1.ownScore
                                                        : ''}
                                                    </TableCell>
                                                    <TableCell>
                                                      {item1.involveFlag === 0
                                                        ? '不涉及'
                                                        : '涉及'}
                                                    </TableCell>
                                                    <TableCell>
                                                      {item1.vdescription}
                                                    </TableCell>
                                                    <TableCell>
                                                      {item1.involveFlag === 1
                                                        ? item1.inspectionScore
                                                        : ''}
                                                    </TableCell>
                                                    <TableCell>
                                                      {item1.involveFlag === 1
                                                        ? item1.scoreDescription
                                                        : ''}
                                                    </TableCell>
                                                  </React.Fragment>
                                                )}
                                              </TableRow>
                                              {!Util.isEmpty(item1.itemList) &&
                                                item1.itemList.map(
                                                  (item2, l) => (
                                                    <TableRow key={l}>
                                                      <TableCell>
                                                        {item2.itemNo}
                                                      </TableCell>
                                                      <TableCell>
                                                        {item2.itemName}
                                                      </TableCell>
                                                      <TableCell>
                                                        {item2.itemScore}
                                                      </TableCell>
                                                      <TableCell>
                                                        {item2.itemDesc}
                                                      </TableCell>
                                                      {detail.status !== 0 && (
                                                        <React.Fragment>
                                                          <TableCell>
                                                            {item2.involveFlag ===
                                                            1
                                                              ? item2.ownScore
                                                              : ''}
                                                          </TableCell>
                                                          <TableCell>
                                                            {item2.involveFlag ===
                                                            0
                                                              ? '不涉及'
                                                              : '涉及'}
                                                          </TableCell>
                                                          <TableCell>
                                                            {item2.vdescription}
                                                          </TableCell>
                                                          <TableCell>
                                                            {item2.involveFlag ===
                                                            1
                                                              ? item2.inspectionScore
                                                              : ''}
                                                          </TableCell>
                                                          <TableCell>
                                                            {item2.involveFlag ===
                                                            1
                                                              ? item2.scoreDescription
                                                              : ''}
                                                          </TableCell>
                                                        </React.Fragment>
                                                      )}
                                                    </TableRow>
                                                  )
                                                )}
                                            </React.Fragment>
                                          ))}
                                      </TableBody>
                                    </Table>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        );
                      }
                    )}
                </TableBody>
                {!Util.isEmpty(detail.materialInspection?.statisticsInfo) && (
                  <TableFooter>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        {detail.materialInspection.statisticsInfo.validMaxScore}
                      </TableCell>
                      <TableCell>
                        {detail.materialInspection.statisticsInfo.selfScoreRate}
                        %
                      </TableCell>
                      <TableCell>
                        {detail.materialInspection.statisticsInfo.auditScore}
                      </TableCell>
                      <TableCell>
                        {
                          detail.materialInspection.statisticsInfo
                            .auditScoreRate
                        }
                        %
                      </TableCell>
                      <TableCell>100%</TableCell>
                      <TableCell>
                        {detail.materialInspection.statisticsInfo.overallScore}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
            </div>
          </div>
        </div>
      </div>

      {self.isPurchase && (
        <Drawer
          anchor="bottom"
          open={auditModal}
          onClose={() => setAuditModal(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="text-filed-item">
                <InputLabel id="demo-simple-select-label">
                  报告评审结果
                </InputLabel>
                <Select
                  value={detail.materialReportResult || ''}
                  label="报告评审结果"
                  onChange={event => {
                    detail.materialReportResult = parseInt(
                      event.target.value,
                      10
                    );
                    forceUpdate();
                  }}
                  className="select-company-list"
                >
                  {!Util.isEmpty(detail.reportResultList) &&
                    detail.reportResultList.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.text}
                      </MenuItem>
                    ))}
                </Select>
              </div>
              {detail.materialReportResult === 2 && (
                <div className="text-field-item">
                  <TextField
                    label="说明"
                    value={detail.useDescription || ''}
                    onChange={event => {
                      detail.useDescription = event.target.value;
                      forceUpdate();
                    }}
                    margin="normal"
                    rows="3"
                    multiline
                    fullWidth
                    variant="outlined"
                  />
                </div>
              )}
              <p className="mt15 m-flex-box">
                <Button
                  type="default"
                  onClick={() => audit()}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确定
                </Button>
                <Button
                  type="default"
                  onClick={() => setAuditModal(false)}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              </p>
            </div>
          </div>
        </Drawer>
      )}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {[0].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                publish();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              发布
            </Button>
          )}

          {[0].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                deleteOrder();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}

          {[2].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleReject();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              退回
            </Button>
          )}

          {User.checkAuth('10051204') &&
            [4].includes(detail.status) &&
            workflow.data &&
            workflow.data['material_report_4']?.complete && (
              <Button
                type="default"
                onClick={() => setAuditModal(true)}
                className="m-flex-item u-btn u-btn_primary"
              >
                审核
              </Button>
            )}
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

BuyoffReportDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyoffReportDetail);
